import React from 'react';
import PropTypes from 'prop-types';

const Toggle = ({ checked, className, onChange, isDisabled, id, ...props }) => (
  <div
    {...props}
    className={`
      toggle-input 
      ${checked ? 'toggle-input-checked' : ''} 
      ${isDisabled ? 'toggle-input-disabled' : ''}
      ${className}
    `}
    onClick={() => !isDisabled && onChange(!checked)}
  >
    <button type="button" className="toggle-input-switch" aria-label={id} />
  </div>
);

Toggle.defaultProps = {
  checked: false,
  className: '',
  id: '',
  onChange: () => {},
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
};

export default Toggle;
